import React from "react";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import ac from './resources/ac.png'



function NavBar() {
  return (
    <Navbar bg="dark" variant="dark" expand="lg" style={{zIndex:1}}>
      <Container>
        <div>

        </div>
        <Navbar.Brand href="home">
          <img src={ac} height={50} className='p-2' alt={'logo'} />
          AirCourt</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <div className='px-3'>
              <Nav.Link href={'https://www.aircourt.live'}>Request a Court</Nav.Link>
            </div>
            <div className='px-3'>
            <Nav.Link href={'https://www.aircourt.live'}>About Us</Nav.Link>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;